import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.receptores.list = {
      ...state.app.receptores.list,
      ...data,
    };
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.receptores.list = {
      ...state.app.receptores.list,
      busy: true,
      filters: {
        ...state.app.receptores.list.filters,
        ...meta,
      },
      pagination: {
        ...state.app.receptores.list.pagination,
        limit: meta.limit ?? 25,
      },
    };
  });

  const { filters, pagination } = store.state.app.receptores.list;

  try {
    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
    };

    const response = await Http.get('api/receptores', { params });

    store.setState((state) => {
      state.app.receptores.list = {
        ...state.app.receptores.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.receptores.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.list.busy = false;
      state.app.receptores.list.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.receptores.list = { ...initialState };
  });
};

const ReceptorListStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    paginate,
    reset,
  },
};

export default ReceptorListStore;
